/**
 * Recently Used Controller
 * Tracks app clicks and maintains list of 5 most recently used apps
 */
export class RecentlyUsedController {
  constructor(storageService, options = {}) {
    this.storage = storageService;
    this.onRecentlyUsedChange = options.onRecentlyUsedChange || (() => {});
    this.recentlyUsed = [];
  }

  async init() {
    this.recentlyUsed = await this.storage.getRecentlyUsed();
    this._bindEvents();
  }

  _bindEvents() {
    // Track clicks on app links - use capturing to run before navigation
    document.addEventListener('click', (e) => {
      const appCard = e.target.closest('.app-card-wrapper[data-app-id]');
      if (!appCard) return;

      // Don't track if clicking the favorite button
      if (e.target.closest('.favorite-btn')) return;

      const appId = appCard.dataset.appId;
      if (appId) {
        // Track the click asynchronously without blocking navigation
        this.trackUsage(appId);
      }
    }, true);
  }

  async trackUsage(appId) {
    this.recentlyUsed = await this.storage.addRecentlyUsed(appId);
    this.onRecentlyUsedChange(this.recentlyUsed, appId);
  }

  getRecentlyUsedAppIds() {
    return this.recentlyUsed.map(item => item.appId);
  }
}
